<template>
  <div class="container mt-5">
    <v-col cols="12">
      <v-card>
        <!-- <div class="card-header bg-dark text-light d-flex align-items-center">
          
        </div> -->
        <v-card-title>
          <button
            class="btn btn-dark btn-sm"
            @click="$router.push('/')"
          >
            <i class="fa fa-arrow-left"></i>
          </button>
          <h4 class="ml-3" v-if="user">Create customer</h4>
          <h4 class="ml-3" v-else>Join Subscription</h4>
        </v-card-title>
        <v-card-text>
          <form @submit.prevent="handleSubmit">
            <v-row>
              <v-col sm="12" md="6" cols="12">
                <v-text-field
                  v-model="membership.fname"
                  label="First Name"
                  :rules="[(v) => !!v || 'First Name is required']"
                  required
                  outlined
                  id="first-name"
                ></v-text-field>
              </v-col>
              <v-col sm="12" md="6" cols="12">
                <v-text-field
                  v-model="membership.lname"
                  label="Last Name"
                  :rules="[(v) => !!v || 'Last Name is required']"
                  required
                  outlined
                  id="last-name"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" :md="refered_by === 'advertisement' ? '4' : '6'">
                <v-select
                  label="Referred By"
                  v-model="refered_by"
                  item-text="name"
                  item-value="value"
                  outlined
                  :items="selectedByList"
                  id="reffered-id"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="12" md="4" v-if="refered_by === 'advertisement'">
                <v-select
                  label="Advertisement"
                  v-model="adItem"
                  item-text="name"
                  item-value="value"
                  outlined
                  :items="itemsAd"
                  id="Advertisement-select"
                >
                </v-select>
              </v-col>
              <v-col sm="12" :md="refered_by === 'advertisement' ? '4' : '6'" cols="12" >
                <v-text-field
                  v-model="refered_by_name"
                  :label="'Promo Code'"
                  outlined
                  id="promo-code"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" sm="12" cols="12">
                <v-text-field
                  v-model="membership.email"
                  :rules="emailRules"
                  label="E-mail"
                  outlined
                  required
                  id="member-email"
                ></v-text-field>
              </v-col>
              <v-col md="6" sm="12" cols="12">
                <v-text-field
                  outlined
                  label="Phone number"
                  prepend-inner-icon="mdi-account"
                  v-model="membership.phone"
                  id="member-phone"
                >
                </v-text-field>
              </v-col>
              <v-col md="12" sm="12" cols="12">
                <DatePicker
                  label="Date of Birth"
                  :monthProps="month"
                  :dayProps="day"
                  :yearProps="year"
                  outlined
                  required
                  v-model="membership.dob"
                  id="DOB"
                ></DatePicker>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12" md="12" cols="12"> 
                <v-text-field
                  outlined
                  label="Street Address"
                  v-model="address.street"
                  id="street-add-id"
                >
                </v-text-field>
              </v-col>
              <v-col sm="12" md="6" cols="12">
                <v-text-field
                  outlined
                  label="Apartment #"
                  v-model="address.apartment"
                  id="add-apartment"
                >
                </v-text-field>
              </v-col>
              <v-col sm="12" md="6" cols="12">
                <v-text-field outlined label="City" v-model="address.city" id="add-city">
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="State"
                  v-model="address.state"
                  outlined
                  :items="getUsaStates"
                  id="pic-state"
                >
                </v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field outlined label="Zip Code" v-model="address.zip" id="enter-zip-id">
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  label="Membership Type"
                  v-model="membership.planType"
                  outlined
                  :items="getPlantypeList"
                  item-text="name"
                  item-value="value"
                  id="member-plan-type"
                >
                </v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <StripeElementCard
                  ref="elementRef"
                  id="card-number"
                  :pk="pulishableKey"
                  @token="tokenCreated"
                  :elementStyle="{
                    base: {
                      color: '#000',
                      fontWeight: '500',
                      fontSize: '16px',
                      fontSmoothing: 'antialiased',
                      ':-webkit-autofill': {
                        color: '#fce883',
                      },
                      '::placeholder': {
                        color: '#000',
                      },
                    },
                  }"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="10">
                <v-text-field
                  v-model="coupon"
                  label="Coupon"
                  outlined
                  id="coupon-code"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="2">
                <v-btn
                  block
                  color="error"
                  x-large
                  :loading="applying"
                  @click="applied = false; coupon = ''"
                  v-if="applied"
                >
                  Remove
                </v-btn>
                <v-btn
                  v-else
                  block
                  color="primary"
                  x-large
                  :loading="applying"
                  @click="applyCoupon"
                >
                  Apply
                </v-btn>
              </v-col>
            </v-row>
            <v-row v-if="applied && couponData.id">
              <v-col sm="12" cols="12" style="margin-top: 0">
                <div class="font-weight-bold">
                  {{ couponData.commitment }}
                </div>
                <div class="font-weight-bold">
                  {{ couponData.description }}
                  <br>
                  <div class="font-weight-bold">
                    Initiation discount: ${{ couponData.discountInitiation }}
                  </div>
                  <div class="font-weight-bold">
                    Monthly discount: ${{ couponData.discountMonthly }}
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <h4>Please sign below</h4>
                <div class="border">
                  <VueSignaturePad
                    width="100%"
                    height="250px"
                    ref="signaturePad"
                    :options="{ onEnd }"
                  />
                </div>
              </v-col>
            </v-row>
            <div class="form-group">
              <!-- signature pad -->
              <div class="row mt-2">
                <div
                  class="col-sm-12 col-md-4 offset-md-8 text-right align-right"
                >
                  <v-btn
                    color="primary"
                    class="mr-2"
                    large
                    @click="clearSignature"
                    id="clear-form-btn"
                  >
                    Clear
                  </v-btn>
                </div>
              </div>
            </div>

            <div class="form-group d-flex">
              <v-checkbox
                id="checkbox-1"
                v-model="status"
                name="checkbox-1"
                value="accepted"
                unchecked-value="not_accepted"
              >
                <template v-slot:label>
                  <span class="mr-2" role="button" @click="termsDialog = true"
                    >I agree to <span class="text-decoration-underline"> Terms & Conditions </span></span
                  ><i class="fa fa-external-link"></i>
                </template>
              </v-checkbox>
            </div>
            <div class="form-group mt-2">
              <v-btn
                color="primary"
                class="mr-2"
                block
                large
                type="submit"
                :loading="loading"
                id="send-email-button"
              >
                Submit
              </v-btn>
            </div>
          </form>
        </v-card-text>
      </v-card>
    </v-col>

    <v-dialog v-model="termsDialog" width="800px">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Terms and Conditions
        </v-card-title>
        <v-card-text>
          <div>
            <Terms
              :planType="getPlan"
              :name="membership.fname + ' ' + membership.lname"
              :phone="membership.phone"
              :email="membership.email"
              :dob="membership.dob"
              :address="getAddress"
            />

            <div class="mt-5 mb-3" style="margin: 0 5%">
              <v-btn
                block
                color="primary"
                dark
                @click="
                  () => {
                    status = 'accepted';
                    termsDialog = false;
                    handleSubmit();
                  }
                "
                type="button"
                class="mr-2"
                large
                :loading="loading"
              >
                Accept
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { storage } from "@/modules/database";
import { mapGetters } from "vuex";
import moment from "moment";
import { StripeElementCard } from "@vue-stripe/vue-stripe";
import axios from "../modules/axios";
import Terms from "../components/Terms.vue";
import DatePicker from "../components/picker/DatePicker.vue";
import constants from "../modules/constants";
const { api_keys } = constants

export default {
  data() {
    return {
      coupon: "",
      applied: false,
      applying: false,
      couponData: {},
      membership: {
        fname: "",
        lname: "",
        dob: "",
        front_dl: "",
        back_dl: "",
        front_insurance: "",
        back_insurance: "",
        email: "",
        countryCode: "+1",
        phone: "",
        address: "",
        planType: "",
        priceType: "",
        signature: "",
      },
      adItem: "",
      selectedByList: [
        {
          name: "None",
          value: "",
        },
        {
          name: "Sales Representative",
          value: "sales_rep",
        },
        {
          name: "Advertisement",
          value: "advertisement",
        },
        {
          name: "Refferal",
          value: "refferal",
        },
        {
          name: "Other",
          value: "refered_by",
        },
      ],
      itemsAd: [
          {
            name: "Facebook",
            value: "facebook",
          },
          {
            name: "Instagram",
            value: "instagram",
          },
          {
            name: "Flyer",
            value: "flyer",
          },
          {
            name: "Other",
            value: "other",
          }
        ],
      getPlantypeList: [
        // {
        //   name: "Any Day Subscription ($350 Initial Payment and $500/month After 45 days) + Taxes.",
        //   value: "weekendnew",
        // },
        // {
        //   name: "Weekday Subscription ($100 Initial Payment and $350/month after 45 days) + Taxes.",
        //   value: "weekday100new",
        // },
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      plans: [],
      refered_by: "",
      refered_by_name: "",
      showImage: false,
      imageShow: "",
      formLoader: false,
      supportList: [],
      loading: false,
      termsDialog: false,
      status: "not_accepted",
      year: "",
      month: "",
      day: "",
      address: {
        street: "",
        apartment: "",
        city: "",
        state: "Washington",
        zip: "",
      },
      addresses: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
    }),
    pulishableKey() {
      return api_keys.STRIPE_KEY
    },
    model: {
      get() {
        return this.support.DateandTime;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    getYear() {
      // get last 100 years
      let years = [];
      for (let i = moment().year() - 24; i > moment().year() - 120; i--) {
        years.push(i);
      }
      return years;
    },
    getMonth() {
      // get last 12 months
      let months = [];
      for (let i = 1; i <= 12; i++) {
        months.push(i);
      }
      return months;
    },
    getDay() {
      // get last 31 days
      let days = [];
      for (let i = 1; i <= 31; i++) {
        days.push(i);
      }
      return days;
    },
    getUsaStates() {
      return [
        "Alabama",
        "Alaska",
        "Arizona",
        "Arkansas",
        "California",
        "Colorado",
        "Connecticut",
        "Delaware",
        "Florida",
        "Georgia",
        "Hawaii",
        "Idaho",
        "Illinois",
        "Indiana",
        "Iowa",
        "Kansas",
        "Kentucky",
        "Louisiana",
        "Maine",
        "Maryland",
        "Massachusetts",
        "Michigan",
        "Minnesota",
        "Mississippi",
        "Missouri",
        "Montana",
        "Nebraska",
        "Nevada",
        "New Hampshire",
        "New Jersey",
        "New Mexico",
        "New York",
        "North Carolina",
        "North Dakota",
        "Ohio",
        "Oklahoma",
        "Oregon",
        "Pennsylvania",
        "Rhode Island",
        "South Carolina",
        "South Dakota",
        "Tennessee",
        "Texas",
        "Utah",
        "Vermont",
        "Virginia",
        "Washington",
        "West Virginia",
        "Wisconsin",
        "Wyoming",
      ];
    },
    // getDOB() {
    //   // const dob = `${this.year}-${this.month}-${this.day}`;
    //   // get timestamp from dob
    //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    //   // this.membership.dob = moment(dob).utc().format("YYYY-MM-DD");
    //   return `${this.month}-${this.day}-${this.year}`;
    // },
    getAddress() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.membership.address = `${this.address.street} ${this.address.apartment} ${this.address.city} ${this.address.state} ${this.address.zip}`;
      return `${this.address.street} ${this.address.apartment} ${this.address.city} ${this.address.state} ${this.address.zip}`;
    },
    getPlan() {
      const planSelected = this.plans.find(
        (plan) => plan.id === this.membership.planType
      );
      if (planSelected) {
        return planSelected.title + ' ' + planSelected.subtitle;
      }
      return "Not Found";
    },
  },
  components: {
    StripeElementCard,
    Terms,
    DatePicker,
  },
  mounted() {
    this.parseQuery();
    this.getPlans();
    this.fetchAddress();
  },
  methods: {
    uploadFile(file, type) {
      const fileName = `document-${type}-${new Date().getTime()}`;
      const storageRef = storage.ref(`/routeline-subscription/${fileName}`);
      const uploadFile = storageRef.put(file);

      return new Promise((resolve, reject) => {
        uploadFile.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            console.log("Upload is " + progress + "% done");
          },
          (error) => {
            console.log(error);
            reject();
          },
          () => {
            uploadFile.snapshot.ref.getDownloadURL().then((downloadURL) => {
              resolve({ downloadURL, type });
            });
          }
        );
      });
    },
    getTime(time) {
      return moment(time * 1000).format("lll");
    },
    getUserName() {},
    changeCountryCode({ dialCode }) {
      this.membership.countryCode = "+" + dialCode;
    },
    validateAndAccept() {
      if (!this.membership.signature) {
        this.$root.toast("Please sign above");
        return;
      }
      // check usa zip code is valid
      if (this.address.zip.length !== 5) {
        if (!/^\d{5}(?:[-\s]\d{4})?$/.test(this.address.zip)) {
          this.$root.toast("Please enter valid zip code");
          return;
        }
        return;
      }

      this.termsDialog = true;
    },
    handleSubmit() {
       /// is valid phone number match with regex
      const phoneRegex = /^\+?[0-9]{10}$/;
      if ( !phoneRegex.test(this.membership.phone) )  {
        this.$root.toast("Please enter valid phone number", "error");
        return;
      }

      if (!this.membership.signature) {
        this.$root.toast("Please sign above", "error");
        return;
      }
      // check usa zip code is valid
      if (this.address.zip.toString().length !== 5) {
        if (!/^\d{5}(?:[-\s]\d{4})?$/.test(this.address.zip)) {
          this.$root.toast("Please enter valid zip code", "error");
          return;
        }
        return;
      }

      if ( this.status !== "accepted" ) {
        this.termsDialog = true;
        return;
      }

      this.$refs.elementRef.submit();
    },
    tokenCreated(token) {
      if (!token) {
        this.loading = false;
        this.$root.toast("Please check card details");
        return;
      }

      this.loading = true;
      this.saveMembership(token);
    },
    async saveMembership(token) {
      try {
        const uid = this.user?.uid || 0;

        await axios.post("/membership", {
          firstName: this.membership.fname,
          lastName: this.membership.lname,
          dob: this.membership.dob,
          email: this.membership.email,
          referredBy: `${this.refered_by} ${this.adItem}, ${this.refered_by_name}`,
          phone: this.membership.countryCode + this.membership.phone,
          createdBy: uid.toString(),
          address: {
            street: this.address.street,
            apartment: this.address.apartment,
            city: this.address.city,
            state: this.address.state,
            zip: this.address.zip.toString(),
          },
          plan: this.membership.planType.toString(),
          signature: this.membership.signature,
          cardID: token.card.id,
          token: token.id,
          coupon: this.applied ? this.coupon : "",
        });

        // const Name = this.membership.fname + " " + this.membership.lname;
        // const { email, phone, address } = this.membership;
        // const dBirth = moment(this.membership.dob).format("MM-DD-YYYY");

        // await this.mutation(Name, email, phone, dBirth, address);

        this.$root.toast("Membership Subscribed");
        this.membership = {
          fname: "",
          lname: "",
          dob: "",
          front_dl: "",
          back_dl: "",
          front_insurance: "",
          back_insurance: "",
          email: "",
          countryCode: "+1",
          phone: "",
          address: "",
          planType: "",
          priceType: "",
          signature: "",
        };

        this.year = "";
        this.month = "";
        this.day = "";
        this.address = {
          street: "",
          apartment: "",
          city: "",
          state: "Washington",
          zip: "",
        };
        this.status = "not-accepted";

        if (this.user?.uid) {
          window.location.href = window.location.origin + "/profile";
          // this.$router.push("/profile");
        } else {
           window.location.href = window.location.origin + "/login";
          // this.$router.push("/login");
        }
      } catch (error) {
        if (error.response.data.code == "customer_tax_location_invalid") {
          this.$root.toast("Please enter valid zip code");
          return;
        }
        if (error.response.data.code == "auth/invalid-phone-number") {
          this.$root.toast("Please enter valid phone number");
          return;
        }
        this.$root.toast("Error Subscribing");
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    onEnd() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      if (isEmpty) {
        return;
      }
      this.membership.signature = data;
    },
    clearSignature() {
      this.membership.signature = "";
      this.$refs.signaturePad.clearSignature();
    },
    getPlans() {
      axios.get(`/plan`).then((res) => {
        this.plans = res.data;
        let newplan = [];
        this.plans.forEach((plan) => {
          const desc = plan.description?.split("~");
          newplan.push({
            ...plan,
            name: plan.title + " " + plan.subtitle + ` (${desc?.[0] || ''}) + Taxes`,
            value: plan.id,
          });
        });
        this.getPlantypeList = newplan;
      });
    },
    fetchAddress() {
      if ( !this.user?.uid ) {
        return;
      }

      axios.get(`/address`)
      .then((res) => {
        this.addresses = res.data;
        if ( this.addresses?.length ) {
          const { city, line1, state, zip } = this.addresses[0];
          this.address = {
            street: line1,
            apartment: "",
            city,
            state: state === "WA" ? "Washington" : state,
            zip: zip,
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    parseQuery() {
      const query = this.$route.query;
      // this.membership.planType = query;
      // convert to string
      if (this.user?.dob) {
        this.year = this.user?.dob.split("-")[0];
        this.month = this.user?.dob.split("-")[1];
        this.day = this.user?.dob.split("-")[2];
      }
      this.membership = {
        fname: this.user?.fName || "",
        lname: this.user?.lName || "",
        dob: this.user?.dob.toString() || "",
        email: this.user?.email || "",
        countryCode: "+1",
        phone: this.user?.phoneNumber.slice(2, 12) || "",
        front_dl: "",
        back_dl: "",
        front_insurance: "",
        back_insurance: "",
        address: "",
        planType: Number(query.plan),
        priceType: "",
        signature: "",
      };
    },
    async applyCoupon() {
      if ( !this.coupon ) {
        this.$root.toast("Please enter a valid coupon", "error");
        return;
      }
      try {
        this.applying = true

        const response = await axios.post(`/coupon-member-apply/${this.coupon.toUpperCase()}`);
        this.couponData = response.data.data;
        this.applied = true;
        this.$root.toast("Coupon Applied", "success");
      } catch (error) {
        this.$root.toast(error?.response?.data?.message || "Something went wrong.", "error");
      } finally {
        this.applying = false
      }
    }
  },
};
</script>

<style>
/* .addinput {
  background-color: #e9ecef;
  border: 0;
  color: black;
} */
.border {
  border: 1px solid var(--primary-color);
}
.input {
  height: 50px;
  opacity: 1;
}
.color-primary {
  background-color: var(--primary-color);
}
.attachment-image {
  display: inline;
  width: 80px;
  height: 80px;
  object-fit: cover;
  margin: 2px;
  border: 1px solid var(--primary-color);
}
</style>
